const BUILD_MY_PLAYLIST = {
  en: 'Build My Playlist',
  es: 'Crear mi playlist',
  fr: 'Créer ma playlist',
  de: 'Meine Playlist erstellen',
  it: 'Crea la mia playlist',
  pt: 'Criar minha playlist',
  ja: 'マイプレイリストを作成',
  ko: '내 플레이리스트 만들기',
  zh: '创建我的播放列表',
  nl: 'Mijn playlist maken', sv: 'Skapa min spellista',
};

export function buildMyPlaylistLabel(lang) {
  return BUILD_MY_PLAYLIST[lang] || BUILD_MY_PLAYLIST.en;
}
